import { userStatusChanged } from './auth';

const changeUserStatus = () => (dispatch, getState) => {
  return dispatch(userStatusChanged());
};

export default changeUserStatus;
